import { BlameLogType, CaseMergeDirection, } from '@debbie/common/dist/blamelog/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ButtonDrop from '../../ButtonDrop.js';
import { CasePreview, Table } from '../../index.js';
import { Meta } from './style.js';
export const CaseLifecycleDetails = ({ blamelog }) => {
    const [open, setOpen] = useState(false);
    return (React.createElement(ButtonDrop, { open: open, onOpen: () => setOpen(true), onClose: () => setOpen(false), size: "mini", info: true, maxWidth: "500px", minWidth: "500px" },
        React.createElement(Meta, null,
            React.createElement(Table, { zebra: true },
                React.createElement(CaseLifecycleDetailsContent, { blamelog: blamelog })))));
};
const CaseLifecycleDetailsContent = ({ blamelog }) => {
    switch (blamelog.type) {
        case BlameLogType.CaseCreate:
            return React.createElement(CaseCreateContent, { blamelog: blamelog });
        case BlameLogType.CaseDelete:
            return React.createElement(CaseDeleteContent, { blamelog: blamelog });
        case BlameLogType.CaseMerge:
            return React.createElement(CaseMergeContent, { blamelog: blamelog });
        case BlameLogType.CaseStatusChange:
            return React.createElement(CaseStatusChangeContent, { blamelog: blamelog });
        default:
            return null;
    }
};
const CaseCreateContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null, details.caseSeqId && (React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement("b", null, lang.blameLogs.caseSeqId)),
        React.createElement("td", null,
            "#",
            details.caseSeqId)))));
};
const CaseDeleteContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        details.previousStatus && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.previousStatus)),
            React.createElement("td", null, lang.cases.caseStatus[details.previousStatus] || details.previousStatus))),
        details.reason && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.reason)),
            React.createElement("td", null, details.reason)))));
};
const CaseMergeContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.direction)),
            React.createElement("td", null, details.direction === CaseMergeDirection.MergedTo
                ? lang.blameLogs.mergedTo
                : lang.blameLogs.mergedFrom)),
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.fromCase)),
            React.createElement("td", null,
                React.createElement(CasePreview, { caseId: `${details.fromCaseSeqId}`, noTooltip: true }))),
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.toCase)),
            React.createElement("td", null,
                React.createElement(CasePreview, { caseId: `${details.toCaseSeqId}`, noTooltip: true })))));
};
const CaseStatusChangeContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.fromStatus)),
            React.createElement("td", null, lang.cases.caseStatus[details.fromStatus] || details.fromStatus)),
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.toStatus)),
            React.createElement("td", null, lang.cases.caseStatus[details.toStatus] || details.toStatus)),
        details.reason && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.reason)),
            React.createElement("td", null, details.reason)))));
};
//# sourceMappingURL=CaseLifecycleDetails.js.map